import SaveStaffRequest from "@/usecases/requests/save-staff-request";

// 編集用の元データなのでRequestと同じ
export default class EditStaffResponse implements SaveStaffRequest {
  id: number = 0;
  officeId: number = 0;
  roleId: number = 0;
  workTypeIds: number[] = [];
  name: string = "";
  tel: string = "";
  email: string = "";
  hasRole: boolean = false;
}
